export interface BuyerCardFinancials {
	cardsCount: number
	cardsBalance: number
}

export const buildBuyerCardFinancials = (
	cards: readonly ICardSaved[] = []
): Map<string, BuyerCardFinancials> => {
	const result = new Map<string, BuyerCardFinancials>()

	cards.forEach((card) => {
		if (!card.user_uid) return
		const current = result.get(card.user_uid) || { cardsCount: 0, cardsBalance: 0 }
		current.cardsCount += 1
		current.cardsBalance += Number(card.balance || 0)
		result.set(card.user_uid, current)
	})

	return result
}

export const buildBuyerSpendMap = (
	buyers: readonly ITopBuyerStatsEntry[] = []
): Map<string, number> =>
	new Map(buyers.map((buyer) => [buyer.user_uid, Number(buyer.amount || 0)]))

